import { render } from "../templates/selection-result.html?vue&type=template&id=6cac9ed3"
import script from "./SelectionResult.vue?vue&type=script&lang=js"
export * from "./SelectionResult.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__